//===================Portfolio Helper =================
export const allPortfoiloEvents = [
  {
    id: 1,
    image: '/assets/images/portfolio/All/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/All/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/All/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/All/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/All/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/All/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/All/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/All/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/All/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/All/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/All/11.png',
  },
];
export const detailData = [
  {
    id: 1,
    image: '/assets/images/portfolio/All/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/All/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/All/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/All/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/All/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/All/6.png',
  },
];


export const allPortfolioCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/privateBirthdayParty/1.png',
    date:'AUGUST 19-2019',
    title: 'Events',
    subTitle: 'By: De evente events',
  },
];
export const corporativeCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/privateBirthdayParty/1.png',
    date:'AUGUST 19-2019',
    title: 'Product Lunches',
    subTitle: 'By: De evente events',
  },
];
export const entertainmentCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/entertainmentMusic/7.png',
    date:'AUGUST 19-2019',
    title: 'Musical Concert',
    subTitle: 'By: De evente events',
  },
];
export const privateCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/privateBirthdayParty/1.png',
    date:'AUGUST 19-2019',
    title: 'Birthday Party',
    subTitle: 'By: De evente events',
  },
];

//===================Private Portfolio Helper =================
export const privateBirthdayData = [
  {
    id: 1,
    image: '/assets/images/portfolio/privateBirthdayParty/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/privateBirthdayParty/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/privateBirthdayParty/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/privateBirthdayParty/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/privateBirthdayParty/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/privateBirthdayParty/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/privateBirthdayParty/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/privateBirthdayParty/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/privateBirthdayParty/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/privateBirthdayParty/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/privateBirthdayParty/11.png',
  },
];
export const nikkahData = [
  {
    id: 1,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/privateBirthdayParty/nikkah/11.png',
  },
];
export const mayonData = [
  {
    id: 1,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/privateBirthdayParty/mayon/11.png',
  },
];
export const baraatData = [
  {
    id: 1,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/privateBirthdayParty/baraat/11.png',
  },
];
export const walimaData = [
  {
    id: 1,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/privateBirthdayParty/walima/11.png',
  },
];

//===================Entertainment Portfolio Helper =================
export const entertainmentData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/11.png',
  },
];
export const fashionShowData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/fashionShow/11.png',
  },
];
export const promotionPartiesData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic//1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/promotionalParties/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/promotionalParties/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/promotionalParties/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/promotionalParties/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/11.png',
  },
];
export const adultPartyData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/11.png',
  },
];
export const apericiationData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/11.png',
  },
];
export const musicalNightData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/2.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/5.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/3.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/1.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/2.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/musicalNight/4.png',
  },
];
export const qawaliNightData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/11.png',
  },
];
export const thematicPartiesData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/11.png',
  },
];
export const tradeShowData = [
  {
    id: 1,
    image: '/assets/images/portfolio/entertainmentMusic/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/entertainmentMusic/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/entertainmentMusic/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/entertainmentMusic/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/entertainmentMusic/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/entertainmentMusic/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/entertainmentMusic/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/entertainmentMusic/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/entertainmentMusic/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/entertainmentMusic/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/entertainmentMusic/11.png',
  },
];

//===================Corporate Portfolio Helper =================
export const coperativeData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/11.png',
  },
];
export const awardData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/awardCeremony/11.png',
  },
];
export const businessData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/businessMeeting/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/businessMeeting/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/businessMeeting/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/businessMeeting/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/businessMeeting/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/conferenceMeeting/9.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/businessMeeting/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/businessMeeting/11.png',
  },
];
export const conferenceData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/11.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/9.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/conferenceMeeting/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/conferenceMeeting/9.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/conferenceMeeting/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/conferenceMeeting/11.png',
  },
];
export const corporateMeetingData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/corporateMeeting/11.png',
  },
];
export const executiveData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/executiveMeeting/11.png',
  },
];
export const exhibitionData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/exhibitionMeeting/11.png',
  },
];
export const pressConferenceData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/pressConference/11.png',
  },
];
export const techData = [
  {
    id: 1,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/1.png',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/2.png',
  },
  {
    id: 3,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/3.png',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/4.png',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/5.png',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/6.png',
  },
  {
    id: 7,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/7.png',
  },
  {
    id: 8,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/8.png',
  },
  {
    id: 9,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/9.png',
  },
  {
    id: 10,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/10.png',
  },
  {
    id: 11,
    image: '/assets/images/portfolio/coperativeProduct/techEvent/11.png',
  },
];

//===================Corporate Portfolio Card Data Helper =================
export const corporateMeetCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Corporate Meeting',
    subTitle: 'By: De evente events',
  },
];
export const executiveCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Executive Events',
    subTitle: 'By: De evente events',
  },
];
export const pressCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Press Conference',
    subTitle: 'By: De evente events',
  },
];
export const conferenceCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Conference',
    subTitle: 'By: De evente events',
  },
];
export const businessMeetCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Business Retrieve',
    subTitle: 'By: De evente events',
  },
];
export const exhibitionCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Exhibitions',
    subTitle: 'By: De evente events',
  },
];
export const awardCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Award Ceremony',
    subTitle: 'By: De evente events',
  },
];
export const techCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Tech Event',
    subTitle: 'By: De evente events',
  },
];

//===================Private Portfolio Card Data Helper =================
export const nikkahCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/privateBirthdayParty/nikkah/2.png',
    date:'AUGUST 19-2019',
    title: 'Nikkah Event',
    subTitle: 'By: De evente events',
  },
];
export const mayonCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/privateBirthdayParty/mayon/2.png',
    date:'AUGUST 19-2019',
    title: 'Mayon Event',
    subTitle: 'By: De evente events',
  },
];
export const baraatCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/privateBirthdayParty/baraat/5.png',
    date:'AUGUST 19-2019',
    title: 'Baraat Event',
    subTitle: 'By: De evente events',
  },
];
export const walimaCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/privateBirthdayParty/walima/7.png',
    date:'AUGUST 19-2019',
    title: 'Walima Event',
    subTitle: 'By: De evente events',
  },
];

//===================Entertainment Portfolio Card Data Helper =================
export const musicalCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Musical Events',
    subTitle: 'By: De evente events',
  },
];
export const fashionCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Fashion Shows',
    subTitle: 'By: De evente events',
  },
];
export const promotionalCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Promotional parties',
    subTitle: 'By: De evente events',
  },
];
export const aperciationCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Employee Apericiation',
    subTitle: 'By: De evente events',
  },
];
export const musicalNCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Musical Night',
    subTitle: 'By: De evente events',
  },
];
export const partyCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Adult Parties',
    subTitle: 'By: De evente events',
  },
];
export const tradeCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Trade Show',
    subTitle: 'By: De evente events',
  },
];
export const themeCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Thematic Parties',
    subTitle: 'By: De evente events',
  },
];
export const qawaliCardData = [
  {   
    id:1, 
    img:'/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    date:'AUGUST 19-2019',
    title: 'Qawali Night',
    subTitle: 'By: De evente events',
  },
];


export const corporativeDetailPage=[
  {
    id:0,
    middleTitle: 'CORPORATIVE EVENTS',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    desc:'We specialize in not only planning and hosting extravagant and large events but also have diverse experience in producing ideas and managing intimate yet beautiful gatherings too! All your weddings, engagement parties, and beautiful receptions are all entertained at Mahara with intricate detail to make your event wholesome, memorable, and overall PERFECT! Our team of professionals is trained to meet the expectations of our clients through and through. We make sure our clients are dealt with class, professionalism, and compassion. After all, “A HUMAN NEVER REMEMBERS'
  }
]
export const entertainmentDetailPage=[
  {
    id:0,
    middleTitle: 'ENTERTAINMENT EVENTS',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    desc:'We specialize in not only planning and hosting extravagant and large events but also have diverse experience in producing ideas and managing intimate yet beautiful gatherings too! All your weddings, engagement parties, and beautiful receptions are all entertained at Mahara with intricate detail to make your event wholesome, memorable, and overall PERFECT! Our team of professionals is trained to meet the expectations of our clients through and through. We make sure our clients are dealt with class, professionalism, and compassion. After all, “A HUMAN NEVER REMEMBERS'
  }
]
export const privateDetailPage=[
  {
    id:0,
    middleTitle: 'PRIVATE EVENTS',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    desc:'We specialize in not only planning and hosting extravagant and large events but also have diverse experience in producing ideas and managing intimate yet beautiful gatherings too! All your weddings, engagement parties, and beautiful receptions are all entertained at Mahara with intricate detail to make your event wholesome, memorable, and overall PERFECT! Our team of professionals is trained to meet the expectations of our clients through and through. We make sure our clients are dealt with class, professionalism, and compassion. After all, “A HUMAN NEVER REMEMBERS'
  }
]